import {
	AnimalPawIcon,
	BookIcon,
	NoteIcon,
	BackpackIcon,
	ClassIcon,
	SpeciesIcon,
	PuzzleIcon,
	ReadingListIcon,
	ScriptIcon,
	SearchIcon,
	SpellBookIcon,
	WikiIcon,
} from '@kit';

import React from 'react';

import {SearchSection} from '../../generated/types';
import {SECTIONS, SectionKey} from '../../lib/seo';

/** Те же иконки, что у разделов в меню */
const ICONS: Record<SearchSection, React.ReactNode> = {
	[SearchSection.classes]: <ClassIcon />,
	[SearchSection.species]: <SpeciesIcon />,
	[SearchSection.origins]: <ScriptIcon />,
	[SearchSection.feats]: <PuzzleIcon />,
	[SearchSection.spells]: <SpellBookIcon />,
	[SearchSection.items]: <BackpackIcon />,
	[SearchSection.monsters]: <AnimalPawIcon />,
	[SearchSection.glossary]: <ReadingListIcon />,
	[SearchSection.books]: <BookIcon />,
	[SearchSection.names]: <NoteIcon />,
	[SearchSection.wiki]: <WikiIcon />,
	[SearchSection.pages]: <SearchIcon />,
};

export function searchSectionIcon(section: SearchSection): React.ReactNode {
	return ICONS[section];
}

/** Разделы поиска совпадают с ключами разделов сайта — название берём оттуда */
export function searchSectionName(section: SearchSection): string {
	if (section === SearchSection.pages) return 'Страницы';
	return SECTIONS[section as string as SectionKey].name;
}
